import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

const FONT_ICON_STYLES = {
  fontSize: '4rem',
  marginBottom: '-1rem',
  marginLeft: '-1rem',
  marginTop: '-1rem',
  marginRight: '-0.5rem'
};

export default (theme: APTheme) => createStyles({
  "@keyframes onloadup": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    }
  },
  commissionsContainer: {
    background: '#F5F5F5',
    color: '#4a4a4a',
    fontSize: 16,
    letterSpacing: '-0.5px',
    height: '100%',
    padding: '34px 35px',
    animationName: `$onloadup`,
    animationDuration: '0.3s',
    animationFillMode: 'both',
    animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
    '@media(max-width: 1200px)': {
      paddingLeft: 110,
    },
    '@media(max-width: 768px)': {
      padding: 30,
    },
    '@media(max-width: 480px)': {
      padding: 20,
    }
  },
  commissionsContainerContent: {
    maxWidth: '1110px',
    position: 'relative',
    height: '100%'
  },
  commissionsChart: {
    background: '#FFF',
    margin: '20px 0',
    padding: 20
  },
  commissionsSection: {
    padding: 30,
    '@media(max-width: 480px)': {
      padding: 20,
    }
  },
  commissionsTable: {
    background: '#FFF'
  },
  downloadButtons: {
  },
  dropDownMenu: {
    position: 'absolute',
    top: -55,
    right: 0,
    '@media(max-width: 480px)': {
      position: 'relative',
      top: 0,
      right: 0,
      width: 'auto',
      padding: '10px 0 0 10px'
    }
  },
  headlines: {
    display: 'flex',
    margin: '15px 0'
  },
  iconDown: {
    ...FONT_ICON_STYLES,
    color: '#FF5F5F'
  },
  iconUp: {
    ...FONT_ICON_STYLES,
    color: '#9BE169'
  },
  miniStatLabel: {
    fontSize: '1.2rem',
    marginLeft: '0.5rem'
  },
  miniStatSummary: {

  },
  miniStatValue: {

  },
  payment: {
    alignItems: 'center',
    color: '#A4A4A4',
    display: 'flex',
    flex: 1,
    fontSize: '1.7rem',
    fontWeight: 400
  },
  paymentAmount: {
    color: '#4A4A4A',
    fontSize: '3.2rem',
    fontWeight: 900,
    marginRight: 10
  },
  paymentDate: {
    color: '#4A4A4A',
    fontWeight: 500,
    marginLeft: '1rem'
  },
  paymentInfo: {

  },
  statementDetail: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))',
    gridGap: '1em',
    '@media(max-width: 570px)': {
      gridTemplateColumns: '100%',
      gridGap: '.5em',
    }
  },
  statementSummary: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(135px, 1fr))',
    gridGap: '1em',
    '@media(max-width: 570px)': {
      gridTemplateColumns: '100%',
      gridGap: '.5em',
    }
  },
  statementHeader: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px 30px',
    '@media(max-width: 480px)': {
      padding: '10px 20px 20px',
    }

  },
  statementTitle: {
    alignItems: 'center',
    borderBottom: '1px solid #E8E8E8',
    display: 'flex',
    marginBottom: 15,
    padding: '15px 0',
    '@media(max-width: 570px)': {
      flexDirection: 'row-reverse',
      display: 'block',
      '& > div': {
        width: '100%',
        marginBottom: 25,
        '&:last-child': {
          marginBottom: 0,
        }
      }
    },
    '@media(max-width: 480px)': {
      paddingTop: '5px'
    }
  },
  statementTitleIntro: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    '@media(max-width: 570px)': {
      width: '100%'
    }
  },
  statementTitleText: {
    color: '#A4A4A4',
    fontSize: 16,
    fontWeight: 'normal'
  },
  statementTitleMonth: {
    color: '#4A4A4A',
    fontSize: 22,
    fontWeight: 'bold'
  },
  statementColumn: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  statementColumnTitle: {
    color: '#A4A4A4',
    fontSize: 13,
    fontWeight: 400,
    marginBottom: 4,
    lineHeight: '1.1'
  },
  statementColumnValue: {
    color: '#4A4A4A',
    fontSize: 16,
    fontWeight: 500,
    '& > span': {
      display: 'inline-block',
      verticalAlign: 'middle',
      '& > img': {
        height: 16
      }
    }
  },
  statementColumnValueLG: {
    color: '#4A4A4A',
    fontSize: 22,
    fontWeight: 700,
  },
  statementSelection: {
    width: 200,
    maxHeight: 42,
    '@media(max-width: 570px)': {
      width: '100%',
    }
  },
  statistics: {
    display: 'flex'
  },
  graphLoader: {
    height: 371,
    position: 'relative'
  },
  graphLoaderSpinner: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    margin: 'auto',
  },
});
